var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex w-100 bg-gray-800 px-4 py-3 text-white justify-content-between"},[_c('div',[_c('small',[_vm._v("Sisas s.p.a. © "+_vm._s(new Date().getFullYear()))])]),_c('div',[_c('router-link',{staticClass:"text-white",attrs:{"to":{ name: 'assistenza' }}},[_c('small',[_vm._v("ASSISTENZA CLIENTI")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }